import { createAction } from "@reduxjs/toolkit";
import { TalesProgramma } from "../../../utils/types/TalesProgramma";

export const setProgrammaData =
  createAction<TalesProgramma[]>("programma/setData");
